export const characterCategoryLabels: Record<string, string> = {
  companionship: '陪伴',
  careers: '职业',
  family: '家庭',
  life: '生活',
  arts: '文艺',
  healthcare: '医护',
}
